jQuery(document).ready(function () {
  jQuery("#det-img2").hide();
  jQuery("#det-img3").hide();
  jQuery("#det-img4").hide();

  jQuery("#det-ctn1").hide();
  jQuery("#det-ctn2").hide();
  jQuery("#det-ctn3").hide();

  jQuery("#det-btn1").click(function () {
    jQuery("#det-img2").show();
    jQuery("#det-img3").hide();
    jQuery("#det-img4").hide();

    jQuery("#det-btn1").hide();
    jQuery("#det-btn2").hide();
    jQuery("#det-btn3").hide();

    jQuery("#det-ctn1").show();
    jQuery("#det-ctn2").hide();
    jQuery("#det-ctn3").hide();
  });

  jQuery("#det-btn2").click(function () {
    jQuery("#det-img3").show();
    jQuery("#det-img2").hide();
    jQuery("#det-img4").hide();

    jQuery("#det-btn1").hide();
    jQuery("#det-btn2").hide();
    jQuery("#det-btn3").hide();

    jQuery("#det-ctn2").show();
    jQuery("#det-ctn1").hide();
    jQuery("#det-ctn3").hide();
  });

  jQuery("#det-btn3").click(function () {
    jQuery("#det-img4").show();
    jQuery("#det-img2").hide();
    jQuery("#det-img3").hide();

    jQuery("#det-btn1").hide();
    jQuery("#det-btn2").hide();
    jQuery("#det-btn3").hide();

    jQuery("#det-ctn3").show();
    jQuery("#det-ctn1").hide();
    jQuery("#det-ctn2").hide();
  });

  jQuery("#cls-btn1").click(function () {
    jQuery("#det-img2").hide();
    jQuery("#det-img3").hide();
    jQuery("#det-img4").hide();

    jQuery("#det-btn1").show();
    jQuery("#det-btn2").show();
    jQuery("#det-btn3").show();

    jQuery("#det-ctn1").hide();
    jQuery("#det-ctn2").hide();
    jQuery("#det-ctn3").hide();
  });

  jQuery("#cls-btn2").click(function () {
    jQuery("#det-img2").hide();
    jQuery("#det-img3").hide();
    jQuery("#det-img4").hide();

    jQuery("#det-btn1").show();
    jQuery("#det-btn2").show();
    jQuery("#det-btn3").show();

    jQuery("#det-ctn1").hide();
    jQuery("#det-ctn2").hide();
    jQuery("#det-ctn3").hide();
  });

  jQuery("#cls-btn3").click(function () {
    jQuery("#det-img2").hide();
    jQuery("#det-img3").hide();
    jQuery("#det-img4").hide();

    jQuery("#det-btn1").show();
    jQuery("#det-btn2").show();
    jQuery("#det-btn3").show();

    jQuery("#det-ctn1").hide();
    jQuery("#det-ctn2").hide();
    jQuery("#det-ctn3").hide();
  });
});

function isOnScreen(elem) {
  if (elem.length == 0) {
    return;
  }
  var $window = jQuery(window);
  var viewport_top = $window.scrollTop();
  var viewport_height = $window.height();
  var viewport_bottom = viewport_top + viewport_height;
  var $elem = jQuery(elem);
  var top = $elem.offset().top;
  var height = $elem.height();
  var bottom = top + height;

  return (
    (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height &&
      top <= viewport_top &&
      bottom >= viewport_bottom)
  );
}

jQuery(document).ready(function () {
  window.addEventListener("scroll", function (e) {
    if (isOnScreen(jQuery("#progress"))) {
      jQuery(".progbar-line").animate(
        {
          width: "0",
        },
        2500
      );
    }
    //      else {
    //          jQuery(".progbar-line").animate({
    //   "width": "100%"
    // }, 2500 );
    //      }
  });

  // custom image-text
  function customImageTexT() {
    
  }
  if (window.innerWidth < 767 && !IsDesignMode) {
   $(document).on("click",".kxti-allow-full-screen", function () {
      $("body").addClass("t4s-lock-scroll");
      // Optional: Enables pinch and zoom
      $("meta[name=viewport]").attr(
        "content",
        "width = device-width, initial-scale = 1.00, minimum-scale = 1.00, maximum-scale = 2.00, user-scalable=yes"
      );
      // Get image path source
      let imagePath = $(this).attr("src");
 
      // Set image path source
      $(".kxti-img-placeholder").attr(
        "style",
        "background-image: url(" + imagePath + ")"
      );
      // Show image
      $(".kxti-img-placeholder").fadeIn();
    });
    $(".kxti-img-placeholder").click(function () {
      // Enables scrolling again
      $("body").removeClass("t4s-lock-scroll");

      // Optional: Disables pinch and zoom
      $("meta[name=viewport]").attr(
        "content",
        "width = device-width, initial-scale = 1.00, minimum-scale = 1.00, maximum-scale = 1.00"
      );

      // Hide image
      $(".kxti-img-placeholder").fadeOut();
    });
  }

  //   video full when click on mobile

  // custom zone
  $(document).on("click",".kxti-custom-zone", function () {
    let data_trigger = $(this).data("trigger");
    //  active tabs
    $(".kxti-custom-zone").parent().find('.kxti-custom-zone.is--active').removeClass("is--active");
    $(this).addClass("is--active");
    //  trigger show variant
    $(".kxti-swatch-item span").removeClass("is--select");
    $(`.${data_trigger}`).addClass("is--select");

    //  console.dir(data_trigger);
    // trigger update title
    let text =
      $(".kxti-custom-zone.is--active").text() +
      " " +
      $(".kxti-swatch-item.is--selected").find(".is--select").text();
    $(".t4s-swatch__current[data-current-value1]").text(text);
    // custom fields
    $(".kxti-custom-fields").attr("name", `properties[${$(this).text().trim().replace(/\r?\n|\r/g, ' ')}]`);
    // $(".kxti-custom-fields").attr("name", 'properties['+$(this).text().trim().replace(/\r?\n|\r/g, ' ')+']');
    $(".kxti-custom-fields").attr(
      "value",
      $(".kxti-swatch-item.is--selected").find(".is--select").text()
    );
  });

  function updateCustomFields() {
    let selectedValue = $(".kxti-swatch-item.is--selected").find(".is--select").text();
    $(".kxti-custom-fields").attr("value", selectedValue);
}

// Run initially
$(document).ready(updateCustomFields);

// Watch for dynamic changes
let observer = new MutationObserver(updateCustomFields);
observer.observe(document.body, { childList: true, subtree: true });

  
  $(document).on("click",".kxti-swatch-item", function () {
    let text =
      $(".kxti-custom-zone.is--active").text() +
      " " +
      $(this).find(".is--select").text();
    $(".t4s-swatch__current[data-current-value1]").text(text);
    // trigger update value fiels
    $(".kxti-custom-fields").attr("value", $(this).find(".is--select").text());
  });

  //

  $(document).on("variant:changed", function (evt) {
    // console.dir(evt.currentVariant);
    // $('[data-current-value1]')[1].innerText = `${evt.currentVariant.option1} ${evt.currentVariant.option2}`;
    // console.log(evt.currentVariant)
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
    // console.dir(evt.currentVariant)
    // $('[data-sticky-img2] img').attr('srcset',evt.currentVariant.featured_image.src);
    // const  section_id = $('[data-sticky-img2]').attr('data-section-id');
    // const color_position =  $('[data-sticky-img2]').attr('data-color-pos');
    // const color_name = evt.currentVariant.options[color_position-1].toLowerCase();
    // const str_class = 'bg_color_'
    // const class_name = str_class.concat(color_name);
    // const data_color = $(`.${class_name}`).css('--t4s-bg-color');
    // $(`.t4s_nt_se_${section_id}`).css('background', data_color);
    // console.dir(data_color)
  });
});

let isVideoPlay = true;
$(document).ready(function () {
  function openFullscreen(id) {
    const elem = document.querySelector(`.${id}`);
    elem.removeAttribute("playsinline");
    if (isVideoPlay == true) {
      elem.pause();
      elem.muted = true;
      isVideoPlay = false;
      elem.parentElement.classList.toggle("is-pause");
    } else {
      if (window.innerWidth < 767) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      }
      elem.play();
      elem.muted = false;
      isVideoPlay = true;
      elem.parentElement.classList.toggle("is-pause");
    }

    // Entering fullscreen mode
    $(elem).bind(
      "webkitfullscreenchange mozfullscreenchange fullscreenchange",
      function (e) {
        let state =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen;
        let event = state ? "FullscreenOn" : "FullscreenOff";

        if (event == "FullscreenOff") {
          //do something when fullscreen on
          console.dir("Exit full screnn video...");
          elem.parentElement.classList.toggle("is-pause");
          elem.pause();
          elem.muted = true;
          isVideoPlay = false;
        }
      }
    );
  }

  $(".openVideo").click(function () {
    openFullscreen(this.dataset.handle);
  });
});

$(document).on("click", ".t4s-mini_cart__remove", function () {
  $(this).css("pointer-events", "none");
});

// handle video aotuplay + sound
// document.addEventListener('DOMContentLoaded',function(){
//   document.querySelectorAll('kxti-video video')?.forEach(el => {
//     el.play();
//   })
// })

function playKxtiVideo() {
  document.querySelectorAll('kxti-video').forEach(function(kxtiEl) {
    // 1. Hide the cover image so video shows through
    const coverImg = kxtiEl.querySelector('img.t4s-img-video');
    if (coverImg) coverImg.style.display = 'none';

    // 2. Target the actual video element (not the one inside <template>)
    const video = kxtiEl.querySelector(':scope > video');
    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');

    video.play().catch(function(e) {
      console.log('Autoplay blocked:', e);
    });
  });
}

// Run on load + retry after 1s for lazy-loaded sections
document.addEventListener('DOMContentLoaded', function() {
  playKxtiVideo();
  setTimeout(playKxtiVideo, 1000);
});

document.addEventListener('shopify:section:load', playKxtiVideo);